import service from "./service"

const getAdditionalDocumentUrl = async ({ requestKey, documentKey }) =>
    service({ requestKey, documentKey })

export default getAdditionalDocumentUrl
